import React from 'react';
import BaseSection from './BaseSection';
import TourTextRenderer from '../../Markdown/TourTextRenderer';
import { Chapter, IImage, StopSection } from '@lialo/core/lib/models';
import routes from '@lialo/core/lib/pages/utils/routes';

interface IProps {
  orderId: number;
  title?: string;
  text?: string;
  images?: IImage[];
  audioSrc?: string;
}

const Information = (props: IProps) => {
  return (
    <BaseSection
      id={routes.generateTourContentHash(Chapter.stop, StopSection.information, props.orderId)}
      title={props.title ?? ''}
      images={props.images}
      // Feature: Text-to-speech
      audioSrc={props.audioSrc}
    >
      <TourTextRenderer source={props.text ?? ''}/>
    </BaseSection>
  );
};

export default Information;
